import React from 'react';
import { connect } from 'react-redux';
import TextField from '@mui/material/TextField';
import setZipAction from '../../redux/actions/createReferenceActions/actionZip'
import { withTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';

const StyledTextField = styled(TextField)({
    '& .MuiOutlinedInput-notchedOutline': {
      '&:hover': {
        borderColor: "rgb(0,191,255)",
      },
      '&.Mui-focused': {
        borderColor: "rgb(47, 79, 79)",
      },
    },
    '& .Mui-focused': {
      color: 'white',
    },
    width: 300,
    marginTop: 10,
    fontSize: 30,
    backgroundColor: 'rgba(19, 174, 236, 0.54)',
    fontWeight: 'bold'
  });

class ZipCodeForm extends React.Component {
    constructor(props) {
        super(props);

        if (this.props.selectedReferenceData && window.location.href.indexOf('/editRef') > -1) {
            this.state = { zip: this.props.selectedReferenceData.zip};
            this.props.setZipFunction(this.state.zip)
        } else {
            this.state = { zip: ''};
            this.props.setZipFunction('defaultZip')
        }
        this.handleChange = this.handleChange.bind(this);
    }

    shouldComponentUpdate(nextProps, nextState) {

        if (this.props.zip !== nextProps.zip) {
            this.setState({ zip: nextProps.zip}, () => {
                this.props.setZipFunction(this.state.zip);
            })
            return false;
        } else {
            return true;
        }
    }

    handleChange(event, value) {
        this.setState({ zip: event.target.value }, () => {
            this.props.setZipFunction(this.state.zip);
        });
      };
    
    setZipEnable() {
        let country_exceptions = ["Rumänien", "Romania","Vereinigte Arabische Emirate", "United Arab Emirates",
        "UAE", "VAE"]
        if(this.props.country) {
            if(country_exceptions.includes(this.props.country)) {
                    return false
            } else {
                    return true
            }
        } else {
            return true
        }
        // Alte Version
        // let email = localStorage.getItem("email");
        // if(email) {
        //     if (email.includes('@mc-bauchemie.ro')) {
        //         return false
        //     } else {
        //         return true
        //     }
        // } else {
        //     return true
        // }
    }
    render() {
        const { t } = this.props;

        return (
            <div>
                <StyledTextField key={this.props.searchVal} onChange={this.handleChange} disabled={this.setZipEnable()}  value={this.state.zip} inputProps={{ maxLength: 30, style: {fontWeight: 'bold'} }} label={t('create_ref.zip') + "*"} variant="outlined" error={this.props.zipError} 
                 style={{ width: 300, marginTop: 10, fontSize: 30, backgroundColor: 'rgba(19, 174, 236, 0.54)' }}/>
            </div>
        )
    }

}
function mapStateToProps(state) {
    return {
        country: state.createRefState.country,
        city: state.createRefState.city,
        zipError: state.createRefState.zipError,
        selectedReferenceData: state.showRefState.selectedReferenceData
    }
}
function mapDispatchToProps(dispatch) {
    return {
        setZipFunction: zip => {
            dispatch(setZipAction(zip));
        }
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ZipCodeForm));